<template>
	<div class="SectionWrapper" :class="{ useGradientBackground }">
		<div v-if="backgroundImage" class="Image"
			:style="{ backgroundImage: `url(${backgroundImage})`, opacity: imageOpacity || .2, 'background-position-x': backgroundImagePositionX || 'center', 'background-position-y': backgroundImagePositionY || 'center' }" />

		<div class="Heading" v-if="title || description">

			<h3>
				{{ title }}
			</h3>
			<p v-if="description" class="Description">{{ description }}</p>
		</div>

		<div v-if="wrapContentWithPadding" :class="{ withPadding: wrapContentWithPadding }">
			<slot />
		</div>
		<slot v-else />
		<slot name="noPadding" />

	</div>
</template>

<script>
import VueTypes from 'vue-types'
import { mediaQueryMixin } from "@/mixins";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

export default {
	name: 'SectionWrapper',
	props: {
		title: VueTypes.string,
		description: VueTypes.string,
		wrapContentWithPadding: VueTypes.bool,
		useGradientBackground: VueTypes.bool,
		backgroundImage: VueTypes.string,
		imageOpacity: VueTypes.number,
		backgroundImagePositionX: VueTypes.string,
		backgroundImagePositionY: VueTypes.string,
	},
	mixins: [mediaQueryMixin],
}
</script>

<style lang="scss" scoped>
.SectionWrapper {
	width: 100%;
	padding: 0;
	max-width: 100%;
	padding-bottom: 2rem;
	padding-top: 2rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	height: auto;
	position: relative;

	* {
		z-index: 1;
	}

	.Image {
		height: 100%;
		width: 100%;
		// opacity: 0.1;
		z-index: 0;
		position: absolute;
		top: 0;
		background-size: cover;
		background-repeat: no-repeat;
		background-position-x: center;
		background-position-y: center;
	}

	// @media screen and (min-width: $xl) {
	// 			width: 1300px;
	// 		}

	// @media screen and (min-width: $xl) {
	// 			padding-left: 0;
	// 			padding-right: 0;
	// 		}

	@media screen and (max-width: $md) {
		padding-bottom: 2rem;
		margin-bottom: 0rem;
		// margin-bottom: 3rem;
		// padding: 2rem;
	}

	&.useGradientBackground {
		background-image: linear-gradient(190deg, rgba(0, 0, 0, .1), transparent);
	}

	.Heading {
		margin: 35px 4rem !important;
		margin-top: 0 !important;

		@media screen and (min-width: $xl) {
			width: 1300px;
			margin-right: 0;
			margin-left: 0;
			align-self: center;
		}

		@media screen and (max-width: $md) {
			margin-right: 2rem !important;
			margin-left: 2rem !important;
		}
	}

	h3 {
		font-size: 2rem;
		line-height: 2rem;
		font-weight: $font-weight-bold;
		color: $primary;
		margin-bottom: .5rem;

		@media screen and (max-width: $md) {
			font-size: 1.5rem;
		}

	}

	.Description {
		font-size: 1rem;
		line-height: 1.5rem;
		color: white;
		font-weight: $font-weight-normal;
		margin: 0;
	}

	p {
		font-size: 1rem;
		line-height: 1.8rem;
		color: white;
	}

	.withPadding {
		padding: 0 4rem;
		width: 100%;

		@media screen and (min-width: $xl) {
			width: 1300px;
			padding: 0;
			align-self: center;
		}

		@media screen and (max-width: $md) {
			padding-right: 2rem !important;
			padding-left: 2rem !important;
		}
	}

}
</style>
